<template>
  <section id="contact" class="contact section">
    <div class="contact-shell reveal-up">
      <div class="contact-copy">
        <h2>Publishing, collaborations, press.</h2>
        <p>
          Use the form or email below to get in touch.
        </p>
        <a href="mailto:contact@zearloops.com" class="btn btn-ghost">contact@zearloops.com</a>
      </div>

      <form class="contact-form" :action="formAction" method="POST">
        <label for="name">Name</label>
        <input type="text" id="name" name="name" placeholder="Your name" required>

        <label for="email">Email</label>
        <input type="email" id="email" name="email" placeholder="you@email.com" required>

        <label for="message">Message</label>
        <textarea id="message" name="message" placeholder="Tell us about your project" rows="5" required></textarea>

        <button type="submit" class="btn btn-primary">Send Message</button>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      formAction: 'https://formspree.io/f/xgvwgaqj'
    };
  }
};
</script>